import { Link } from "react-router-dom";
import { Receipt, FileSpreadsheet, ChevronRight } from "lucide-react";

const card: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 16,
  padding: "20px 22px",
  borderRadius: 14,
  border: "1px solid #e8dfd4",
  background: "white",
  textDecoration: "none",
  color: "inherit",
  transition: "box-shadow 0.2s, border-color 0.2s",
};

export default function FiscaliteHome() {
  return (
    <div style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif", padding: 24, maxWidth: 720 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: "linear-gradient(135deg, rgba(249,115,22,0.15), rgba(234,179,8,0.12))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ea580c",
          }}
        >
          <Receipt size={26} strokeWidth={2} />
        </div>
        <div>
          <h1 style={{ fontSize: "1.35rem", fontWeight: 800, color: "#0f172a", margin: 0 }}>Fiscalité</h1>
          <p style={{ margin: "4px 0 0", fontSize: "0.9rem", color: "#64748b" }}>
            Déclarations et obligations fiscales (DGI Côte d&apos;Ivoire).
          </p>
        </div>
      </div>

      <Link
        to="/compta/fiscalite/tva-board"
        style={card}
        onMouseOver={(e) => {
          e.currentTarget.style.boxShadow = "0 8px 28px rgba(15,23,42,0.08)";
          e.currentTarget.style.borderColor = "#fdba74";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.boxShadow = "none";
          e.currentTarget.style.borderColor = "#e8dfd4";
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            background: "#eff6ff",
            color: "#2563eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FileSpreadsheet size={22} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>Déclaration TVA</div>
          <div style={{ fontSize: "0.85rem", color: "#64748b", lineHeight: 1.45 }}>
            Préparation, calcul depuis la comptabilité, états détaillés et export PDF.
          </div>
        </div>
        <ChevronRight size={20} color="#94a3b8" />
      </Link>
    </div>
  );
}
